import faker from "faker";
import { listDaysFromDate, rangeRandom, numberToPrecisionFloat } from "../helpers";

export default class CashPositionService {
  static generateCashPosition(fromDate = null, days = 7) {
    fromDate = fromDate ?? new Date();
    days = Math.max(1, days);

    let dateList = listDaysFromDate(fromDate, days, true);
    let cashPositions = {};
    let startingBalance = numberToPrecisionFloat(rangeRandom(10000000, 400000000), 2);

    dateList.forEach((dateString) => {
      cashPositions[dateString] = this.generateSingleDayMap(startingBalance);
      startingBalance = cashPositions[dateString].get("ending_available");
    });

    return cashPositions;
  }

  static generateSingleDayMap(startingBalance) {
    let curDayPosition = new Map();
    startingBalance = parseFloat(startingBalance);

    curDayPosition.set("opening_available_balance", startingBalance);
    curDayPosition.set(
      "one_day_float",
      numberToPrecisionFloat(rangeRandom(0, startingBalance * 0.25, true), 2)
    );

    curDayPosition.set("investment_sweep_balance", 0.0);
    curDayPosition.set("float_adjustment", 0.0);

    //VISUAL SECTION BREAK
    curDayPosition.set(
      "cdr_debits",
      numberToPrecisionFloat(rangeRandom(0, startingBalance * 0.25, true), 2)
    );
    curDayPosition.set(
      "cdr_debit_check_paid",
      numberToPrecisionFloat(rangeRandom(0, curDayPosition.get("cdr_debits") * 0.25, true), 2)
    );

    curDayPosition.set(
      "cdr_debit_zba_debit",
      numberToPrecisionFloat(
        curDayPosition.get("cdr_debits") - curDayPosition.get("cdr_debit_check_paid"),
        2
      )
    );

    //VISUAL SECTION BREAK
    curDayPosition.set(
      "pdr_credits",
      numberToPrecisionFloat(rangeRandom(0, startingBalance * 0.25, true), 2)
    );
    curDayPosition.set(
      "pdr_credit_international_transfer",
      numberToPrecisionFloat(rangeRandom(0, curDayPosition.get("pdr_credits") * 0.45, true), 2)
    );

    curDayPosition.set(
      "pdr_credit_zba_credit",
      numberToPrecisionFloat(
        curDayPosition.get("pdr_credits") - curDayPosition.get("pdr_credit_international_transfer"),
        2
      )
    );

    //VISUAL SECTION BREAK
    curDayPosition.set(
      "pdr_debits",
      numberToPrecisionFloat(rangeRandom(0, startingBalance * 0.25, true), 2)
    );

    curDayPosition.set(
      "pdr_debit_check_paid",
      numberToPrecisionFloat(rangeRandom(0, curDayPosition.get("pdr_debits") * 0.25, true), 2)
    );

    curDayPosition.set(
      "pdr_debit_international_transfer",
      numberToPrecisionFloat(rangeRandom(0, curDayPosition.get("pdr_debits") * 0.25, true), 2)
    );

    curDayPosition.set(
      "pdr_debit_zba_debit",
      numberToPrecisionFloat(
        curDayPosition.get("pdr_debits") -
          (curDayPosition.get("pdr_debit_check_paid") +
            curDayPosition.get("pdr_debit_international_transfer")),
        2
      )
    );

    curDayPosition.set(
      "ending_available",
      numberToPrecisionFloat(
        startingBalance -
          curDayPosition.get("cdr_debits") +
          curDayPosition.get("pdr_credits") -
          curDayPosition.get("pdr_debits"),
        2
      )
    );

    return curDayPosition;
  }

  static generateSingleDay(startingBalance) {
    let curDayPosition = {};
    startingBalance = parseFloat(startingBalance);
    curDayPosition["opening_available_balance"] = startingBalance;
    curDayPosition["one_day_float"] = numberToPrecisionFloat(
      rangeRandom(0, startingBalance * 0.25, true),
      2
    );
    curDayPosition["investment_sweep_balance"] = 0.0;
    curDayPosition["float_adjustment"] = 0.0;
    //VISUAL SECTION BREAK
    curDayPosition["cdr_debits"] = numberToPrecisionFloat(
      rangeRandom(0, startingBalance * 0.25, true),
      2
    );
    curDayPosition["cdr_debit_check_paid"] = numberToPrecisionFloat(
      rangeRandom(0, curDayPosition["cdr_debits"] * 0.25, true),
      2
    );
    curDayPosition["cdr_debit_zba_debit"] = numberToPrecisionFloat(
      curDayPosition["cdr_debits"] - curDayPosition["cdr_debit_check_paid"],
      2
    );
    //VISUAL SECTION BREAK
    curDayPosition["pdr_credits"] = numberToPrecisionFloat(
      rangeRandom(0, startingBalance * 0.25, true),
      2
    );
    curDayPosition["pdr_credit_international_transfer"] = numberToPrecisionFloat(
      rangeRandom(0, curDayPosition["pdr_credits"] * 0.45, true),
      2
    );
    curDayPosition["pdr_credit_zba_credit"] = numberToPrecisionFloat(
      curDayPosition["pdr_credits"] - curDayPosition["pdr_credit_international_transfer"],
      2
    );
    //VISUAL SECTION BREAK
    curDayPosition["pdr_debits"] = numberToPrecisionFloat(
      rangeRandom(0, startingBalance * 0.25, true),
      2
    );
    curDayPosition["pdr_debit_check_paid"] = numberToPrecisionFloat(
      rangeRandom(0, curDayPosition["pdr_debits"] * 0.25, true),
      2
    );
    curDayPosition["pdr_debit_international_transfer"] = numberToPrecisionFloat(
      rangeRandom(0, curDayPosition["pdr_debits"] * 0.25, true),
      2
    );
    curDayPosition["pdr_debit_zba_debit"] = numberToPrecisionFloat(
      curDayPosition["pdr_debits"] -
        (curDayPosition["pdr_debit_check_paid"] +
          curDayPosition["pdr_debit_international_transfer"]),
      2
    );
    curDayPosition["ending_available"] = numberToPrecisionFloat(
      startingBalance -
        curDayPosition["cdr_debits"] +
        curDayPosition["pdr_credits"] -
        curDayPosition["pdr_debits"],
      2
    );

    return curDayPosition;
  }
}
